/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import NewsletterForm from '../../forms/NewsletterForm';
import DefaultBonusCard from './DefaultBonusCard';

import styles from '../../../../styles/items/bonus-card-newsletter.module.scss';

const propTypes = {
    id: PropTypes.string,
    handle: PropTypes.string,
    newsletter: PropTypes.string,
    optin: PropTypes.string,
    completed: PropTypes.bool,
    className: PropTypes.string,
    onComplete: PropTypes.func,
};

const defaultProps = {
    id: null,
    handle: null,
    newsletter: null,
    optin: null,
    completed: false,
    className: null,
    onComplete: null,
};

function NewsletterBonusCard({
    handle,
    id,
    newsletter,
    optin,
    completed,
    className,
    onComplete,
    ...props
}) {
    const themeClassName = useThemeClassName(styles);
    return (
        <DefaultBonusCard
            className={classNames([
                styles.container,
                styles[newsletter],
                themeClassName,
                className,
            ])}
            imageClassName={styles.image}
            handle={handle}
            id={id}
            completed={completed}
            {...props}
        >
            {!completed ? (
                <NewsletterForm
                    name={newsletter || handle || `bonus-${id}`}
                    optin={optin}
                    onSuccess={onComplete}
                    submitClassName={styles.submit}
                />
            ) : (
                <div className={styles.completed}>
                    <FormattedMessage
                        defaultMessage="You are subscribed!"
                        description="Bonus message"
                    />
                </div>
            )}
        </DefaultBonusCard>
    );
}

NewsletterBonusCard.propTypes = propTypes;
NewsletterBonusCard.defaultProps = defaultProps;

export default NewsletterBonusCard;
